export default __webpack_public_path__ + "static/media/logo_light_x.81e06d9c.svg";